import { get, trim } from '@/helpers';

export default {
  computed: {
    storageRoute() {
      return trim(
        `${process.env.VUE_APP_API_HTTP}${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE}`,
        '/'
      );
    }
  },
  methods: {
    normalizeQueryString(fit) {
      const params = new URLSearchParams(fit);
      const entries = params.entries();
      const query = trim(
        [...entries]
          .sort((a, b) => a[0].localeCompare(b[0]))
          .reduce((str, item) => {
            return (str += `${item[0]}=${item[1]}&`);
          }, ''),
        '&'
      );
      return query;
    },
    findGeneratedFile(image, fit, optimize = 'speed', debug = false) {
      let url;

      // if (this.debug) console.log(fit)
      const id = image.id;
      const name = get(image, 'source.name') || get(image, 'name');

      if (optimize === 'speed') {
        // const params = new URLSearchParams(get(image, 'pivot.fit') || this.fit);
        const params = new URLSearchParams(fit);
        const entries = params.entries();
        const query = Object.fromEntries(entries);

        // image.srcset excludes other generated files
        const find = files => {
          if (files && files.length) {
            let dimensions = [];
            files.forEach(file => {
              const fileParams = new URLSearchParams(file.type.split('?').pop());
              const fileEntries = fileParams.entries();
              const fileQuery = Object.fromEntries(fileEntries);

              // if (this.debug) console.log(file, fileQuery)

              let match = true;
              let exclude = false;

              if (query.fit && query.fit !== fileQuery.fit) match = false;
              if (query.crop && query.crop !== fileQuery.crop) match = false;
              if (query.x && parseFloat(query.x) !== parseFloat(fileQuery.x)) match = false;
              if (query.y && parseFloat(query.y) !== parseFloat(fileQuery.y)) match = false;
              if (query.z && parseFloat(query.z) !== parseFloat(fileQuery.z)) match = false;

              // if ((!query.preview && fileQuery.preview) || (query.preview && query.preview !== fileQuery.preview)) {
              if (query.preview !== fileQuery.preview) {
                match = false;
                exclude = true;
              }

              // if ((!query.format && fileQuery.format) || (query.format && query.format !== fileQuery.format)) {
              if (query.format !== fileQuery.format) {
                match = false;
                exclude = true;
              }

              if (exclude === false && match && (fileQuery.w || fileQuery.h)) {
                const w = parseFloat(fileQuery.w);
                const h = parseFloat(fileQuery.h);

                if (query.w && query.w > w) match = false;
                if (query.h && query.h > h) match = false;

                const i = dimensions.findIndex(el => el.w === w && el.h === h);
                if (i < 0) dimensions.push({ w, h, match, file });
              }
            });

            let file;
            if (dimensions.length) {
              const matches = dimensions.filter(el => el.match).sort((a, b) => a.w - b.w);
              dimensions.sort((a, b) => b.w - a.w);
              if (matches.length) file = matches[0].file;
              else file = dimensions[0].file;
            }

            if (file && file.url) return file.url;
          }
          return false;
        };

        if (image.srcset && image.srcset.length) url = find(image.srcset);
        if (!url && image.files && image.files.length) url = find(image.files);
      } else {
        const query = this.normalizeQueryString(fit);
        const files = get(image, 'files') || [];
        const file = files.find(el => el.type === query);
        // if (debug) console.log(query, files)

        if (file && file.url) url = file.url;
      }

      if (!url) url = trim(`${this.storageRoute}/images/${id}/${name}?${fit}`, '?');
      return url;
    }
  }
};
